module.exports = __webpack_public_path__ + "static/media/deck-3-super.8846da93.png";